<template>
  <!-- Menú ☰ flotante arriba-izquierda. Despliega las vistas
       (capas) y el modo diseño. Reemplaza al selector de capas + toggle del header.
       Lleva data-action estables porque estos controles no tenían hook de automatización. -->
  <div class="epc-menu">
    <b-dropdown aria-role="list" position="is-bottom-right" :mobile-modal="false">
      <template #trigger>
        <div class="epc-menu-btn" data-action="menu-toggle" role="button" :aria-label="$t('menu')">
          <b-icon icon="bars" pack="fas"></b-icon>
        </div>
      </template>

      <!-- Vistas / capas -->
      <b-dropdown-item custom aria-role="menuitem">
        <span class="text-xs font-semibold text-grey-dark uppercase">{{ $t('view') }}</span>
      </b-dropdown-item>
      <b-dropdown-item v-for="v in views" :key="v.code" aria-role="listitem"
        :data-action="'view-' + v.code"
        :class="{ 'is-active-view': currentView === v.code }"
        @click="selectView(v.code)">
        <b-icon :icon="v.icon" pack="fas" size="is-small"></b-icon> {{ v.labelKey ? $t(v.labelKey) : v.label }}
      </b-dropdown-item>

    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "WidgetMenu",

  props: {
    currentView: { type: String, default: 'structures' },
    designMode: { type: Boolean, default: false },
    showAreas: { type: Boolean, default: false },
    canActions: { type: Object, default() { return {} } },

    /**
     * Vistas a listar en el menú. Cada item: { code, icon, labelKey? , label? }.
     * Default = las 3 vistas de solar-park (retrocompatible: ViewerPageDesign
     * no pasa `views` y sigue igual). Otros consumidores (LayoutBuilder) pasan
     * su propio set.
     */
    views: {
      type: Array,
      default: () => ([
        { code: 'pilings',    icon: 'band-aid',    labelKey: 'pilings' },
        { code: 'structures', icon: 'stream',      labelKey: 'structures' },
        { code: 'modules',    icon: 'solar-panel', labelKey: 'modules' },
      ]),
    },
  },

  methods: {
    selectView(view) {
      this.$emit('epc-open-panel', 'view-' + view);
    },
    _Allowed(action) {
      if (this.canActions[action] === undefined) return true;
      return !!this.canActions[action];
    },
  },
}
</script>

<style scoped>
.epc-menu {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 6;
}

.epc-menu-btn {
  background-color: #ffffff;
  border: 1px solid #e3e3e8;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #343a40;
}

.epc-menu-btn:hover {
  background-color: #f4f4f6;
}

/* Marca la vista/estado activo dentro del menú */
.is-active-view {
  color: #3a6bc8;
  font-weight: 600;
}

/* Espacio entre el icono y el texto en los items de cambio de vista. */
.epc-menu ::v-deep .dropdown-item .icon {
  margin-right: 8px;
}
</style>
